module.exports = __webpack_public_path__ + "static/media/chatbox-fitmatka-image.6a33ae43.webp";